<bb-page-header [icon]="'key'" [title]="'API_KEYS' | translate" [filterConfig]="filterConfig"></bb-page-header>

<div class="body-column">
	<div class="action-buttons">
		<a class="button" [routerLink]="['/publication/api-keys/new']"><i class="fa fa-plus"></i>
			<span class="short-label">{{ 'NEW_KEY' | translate }}</span>
			<span class="long-label">{{ 'CREATE_NEW_KEY' | translate }}</span>
		</a>
	</div>

	<bb-table-container>
		<bb-table-header>
			<bb-table-header-cell property="id" optional>{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="label">{{ 'LABEL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="roles">{{ 'ROLES' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell property="createddate">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="row-actions buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
			<bb-table-cell property="label" class="overflow">{{ row.data.label }}</bb-table-cell>
			<bb-table-cell property="roles" class="overflow">
				<span *ngIf="rolesData && row.data.contextRoles && row.data.contextRoles[ 'publication/' + currentPublicationId ]">
					<!-- <pre [hidden]="row.data.id !== '193'">row.data.contextRoles[ 'publication/' + currentPublicationId ]: {{ row.data.contextRoles[ 'publication/' + currentPublicationId ] | json }}</pre> -->
					<!-- <span *ngFor="let role of row.data.contextRoles[ 'publication/' + currentPublicationId ]; let i = index">
						{{ rolesData[ 'role' + role.id] }}<span [hidden]="row.data.contextRoles[ 'publication/' + currentPublicationId ].length - 1 === i">, </span>
					</span>
					<br /> -->
					<span *ngFor="let roleId of row.data.contextRoles[ 'publication/' + currentPublicationId ]; let i = index">
						{{ rolesData[ 'role' + roleId] }}<span [hidden]="row.data.contextRoles[ 'publication/' + currentPublicationId ].length - 1 === i">, </span>
					</span>
				</span>
			</bb-table-cell>
			<bb-table-cell property="status"><div [innerHtml]="row.data | statusIcon"></div></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
			<bb-table-cell class="buttons row-actions" (click)="$event.stopPropagation()"><!-- stopPropagation so the row doesn't get selected -->
				<a class="button" [routerLink]="['/publication/api-keys/', row.data.id]">
					<i class="fa fa-edit" (easterEgg)="showData(row.id)" ></i>
				</a><!--
				--><a class="button" [ngClass]="{disabled: !putRight}" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a><!--
			--></bb-table-cell>
		</bb-table-row>
	</bb-table-container>
	<bb-table-pager></bb-table-pager>
</div>
